import { TestPage } from '~/pages/home/TestPage'
import type { AppRouteObject } from '~/router/types'
import { SHELL_TEST_NAV_APP_TREE } from '~/test-data/shell'

/** Minimal structural shape of a nav node — enough to derive routes; all three tiers satisfy it. */
interface NavRouteNode {
  id: string
  name: string
  children?: readonly NavRouteNode[] | undefined
}

/** Flatten the app tree into one route per node (full sub-path), carrying its title + ancestor→self
 * breadcrumb (clickable links) in `handle`. Every node renders the shared `TestPage`. */
const buildNavRoutes = (
  nodes: readonly NavRouteNode[],
  trail: { ids: readonly string[]; crumbs: readonly { label: string; to: string }[] } = {
    ids: [],
    crumbs: [],
  },
): AppRouteObject[] =>
  nodes.flatMap((node) => {
    const ids = [...trail.ids, node.id]
    const crumbs = [...trail.crumbs, { label: node.name, to: `/home/${ids.join('/')}` }]
    return [
      {
        path: ids.join('/'),
        handle: { title: node.name, breadcrumb: crumbs },
        Component: TestPage,
      },
      ...buildNavRoutes(node.children ?? [], { ids, crumbs }),
    ]
  })

export const homeRoute: AppRouteObject = {
  path: 'home',
  children: [
    { index: true, handle: { title: 'Home' }, Component: TestPage },
    ...buildNavRoutes(SHELL_TEST_NAV_APP_TREE),
  ],
}
